import { post } from "../utils/axios/axios.config";

class HinduCalendarService {
  constructor() {
    this.baseUrl = "/devine-calendar";
  }

  /**
   * Get Panchang data for a specific date
   * @param {Object} data - Request data containing date information
   * @param {number} data.day - Day of the month (1-31)
   * @param {number} data.month - Month (1-12)
   * @param {number} data.year - Year (e.g., 2024)
   * @param {string} data.place - Place name (e.g., 'Delhi')
   * @param {number} data.lat - Latitude for location-specific calculations
   * @param {number} data.lon - Longitude for location-specific calculations
   * @param {string} data.tzone - Timezone (e.g., 'Asia/Kolkata')
   * @returns {Promise<Object>} Panchang data response
   */
  async getPanchangData(data) {
    try {
      const response = await post(`${this.baseUrl}/get-panchang-data`, data);
      return response;
    } catch (error) {
      throw (
        error?.response?.data ||
        error?.message ||
        "Failed to fetch Panchang data"
      );
    }
  }

  /**
   * Get month-specific events and festivals
   * @param {Object} data - Request data containing month information
   * @param {number} data.year - Year (e.g., 2024)
   * @param {number} data.month - Month (1-12)
   * @param {string} data.place - Place name (e.g., 'Delhi')
   * @param {number} data.lat - Latitude for location-specific calculations
   * @param {number} data.lon - Longitude for location-specific calculations
   * @param {string} data.tzone - Timezone (e.g., 'Asia/Kolkata')
   * @returns {Promise<Object>} Month-specific events response
   */
  async getMonthSpecificEvents(data) {
    try {
      const response = await post(
        `${this.baseUrl}/get-month-specific-events`,
        data
      );
      return response;
    } catch (error) {
      throw (
        error?.response?.data ||
        error?.message ||
        "Failed to fetch month-specific events"
      );
    }
  }
}

const hinduCalendarService = new HinduCalendarService();
export default hinduCalendarService;
